import Cookie from '@nuxt-common/util/app/utils/cookie/Cookie.js';
import { getError, getErrorMessage } from '#utils/ErrorHandler';
import { defineStore } from 'pinia';
import $http from '@vue-util/http';

const WISHLIST_ENDPOINT = '/xapi/wishlist/v1/lists';

export const useDeleteItemStore = defineStore('deleteItem', {
  state: () => ({
    deleteItemError: null,
    deleteItemLoadingState: false,
    deleteItemErrorStatus: false,
  }),
  actions: {
    async deleteItem({ listGuid, itemGuid, headers }) {
      this.deleteItemLoadingState = true;
      this.deleteItemErrorStatus = false;
      this.deleteItemError = null;
      try {
        const response = await $http.delete(`${WISHLIST_ENDPOINT}/${listGuid}/items/${itemGuid}`, {
          headers,
        });
        const responseData = response.data || response;
        if (getError(responseData)) {
          const errorMessage = getErrorMessage(responseData);
          this.deleteItemError = errorMessage;
        }
      } catch (error) {
        if (error.response?.status === 401) {
          Cookie.set('SignedIn', '0');
          this.deleteItemErrorStatus = true;
        }
        const fallbackErrorMessage = getErrorMessage(error.response?.data);
        this.deleteItemError = fallbackErrorMessage;
      } finally {
        this.deleteItemLoadingState = false;
      }
    },
    setDeleteItemError(error) {
      this.deleteItemError = error;
    },
    setDeleteItemLoadingState(loadValue) {
      this.deleteItemLoadingState = loadValue;
    },
    setDeleteItemErrorStatus(value) {
      this.deleteItemErrorStatus = value;
    },
  },
});
